import { TypographyOptions } from "@mui/material/styles/createTypography";

import { COLORS } from "@/utils/colors";

const typography: TypographyOptions = {
  fontFamily: [
    '"Noto Sans JP"',
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  fontSize: 18,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontSize: "1.75rem",
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: 0,
    color: COLORS.TEXT_HEADING,
    marginBottom: 24,
  },
  h2: {
    fontSize: "1.5rem",
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: "0.04em",
    color: COLORS.TEXT_HEADING,
    marginBottom: 24,
  },
  h3: {
    fontSize: "1.25rem",
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: "0.04em",
    color: COLORS.TEXT_HEADING,
    marginBottom: 16,
  },
  h4: {
    fontSize: "1.125rem",
    fontWeight: 700,
    lineHeight: 1.5,
    letterSpacing: "0.04em",
    color: COLORS.TEXT_HEADING,
    marginBottom: 16,
  },
  h5: {
    fontSize: "1rem",
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: "0.04em",
    color: COLORS.TEXT_HEADING,
    marginBottom: 16,
  },
  h6: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: "0.04em",
    color: COLORS.TEXT_HEADING,
    marginBottom: 16,
  },
  body1: {
    fontSize: "1.125rem",
    lineHeight: 1.7,
    letterSpacing: "0.04em",
  },
  button: {
    fontSize: "1.125rem",
    lineHeight: 1.4,
    textTransform: "none",
    letterSpacing: "0.02em",
  },
  caption: {
    fontSize: "0.875rem",
    lineHeight: 1.2,
    letterSpacing: "0.04em",
  },
};

export default typography;
